const getters = {
  tabGroups: (state) => state.tabGroups
};

export default getters;